import ReactDOM from "react-dom";
import "firebase/firestore";
// Persist Layout across client-side navigations so footer (Klaviyo embed, etc.) is not unmounted.
// Page components must not wrap themselves in <Layout> — see src/shared/wrapApp.tsx.
import { wrapPageElement, wrapRootElement } from "./src/shared/wrapApp";

const projectId = process.env.GATSBY_SANITY_PROJECT_ID;
if (projectId === "o289pg0s") {
  require("./static/fonts/fonts-everyday.css");
} else if (projectId === "pbpon7tg") {
  require("./static/fonts/fonts-anathoth.css");
} else {
  require("./static/fonts/fonts-barkers.css");
}

export { wrapPageElement, wrapRootElement };

if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.error = () => {};
}

export const replaceHydrateFunction = () => {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback);
  };
};